export default __webpack_public_path__ + "static/climate-action-0689f3a7696f4cd07e32b1d620a4a77b.png";